import isDev from "./environmentUtils";

export function goToModelSelector(autoPickSurfaceProductArticleNo?: string): void {
    const url = new URL(window.location.href);
    const basePath = isDev()
        ? "http://localhost:3006/"
        : `${url.origin}${url.pathname.replace(/\/configurator\/?(summary)?$/i, "/model_selector/")}`;

    const searchParams = url.searchParams;
    searchParams.delete("config_string");

    // Add the site_url from the parent page if not specified,
    // but only when embedded in an iframe.
    if (window.self !== window.top) {
        const siteUrl = searchParams.get("site_url");
        if (!siteUrl && document.referrer) {
            const referrer = new URL(document.referrer);
            referrer.hash = "";
            referrer.search = "";
            searchParams.set("site_url", referrer.href);
        }
    }

    if (autoPickSurfaceProductArticleNo) {
        searchParams.append("surface_product", autoPickSurfaceProductArticleNo);
    }

    const searchParamsString = searchParams.toString();
    const newLocation = decodeURIComponent(`${basePath}${searchParamsString.length ? `?${searchParamsString}` : ""}`);
    window.location.assign(newLocation);
}

export async function goBackToRoom(configString: string | null): Promise<void> {
    const url = new URL(window.location.href);

    const basePath = `${url.origin}${url.pathname}`; // difference in https and http right?

    const searchParams = url.searchParams;

    // Add the site_url from the parent page if not specified,
    // but only when embedded in an iframe.
    if (window.self !== window.top) {
        const siteUrl = searchParams.get("site_url");
        if (!siteUrl && document.referrer) {
            const referrer = new URL(document.referrer);
            referrer.hash = "";
            referrer.search = "";
            searchParams.set("site_url", referrer.href);
        }
    }

    if (configString !== null) {
        searchParams.set("config_string", configString);
    }

    const searchParamsString = searchParams.toString();
    const sameRoomLocation = decodeURIComponent(
        `${basePath}${searchParamsString.length ? `?${searchParamsString}` : ""}`
    );
    window.location.assign(sameRoomLocation);
}

// Gets the base URL to use for configuration links in emails,
// if not specified from DS Web Admin.
export function getSiteUrl(): string {
    const url = new URL(window.location.href);
    const siteUrlParam = url.searchParams.get("site_url");
    let siteUrl;
    if (siteUrlParam) {
        siteUrl = new URL(siteUrlParam);
    } else if (document.referrer) {
        const referrer = new URL(document.referrer);
        if (referrer.hostname !== url.hostname) {
            siteUrl = referrer;
        }
    }
    if (!siteUrl) {
        siteUrl = url;
    }
    siteUrl.hash = "";
    siteUrl.search = "";
    return siteUrl.href;
}

export function makeUrlLowerCase(url: URL) {
    url.pathname = url.pathname.toLowerCase();
    url.hostname = url.hostname.toLowerCase();
    url.protocol = url.protocol.toLowerCase();
}
